class FieldTierVisibility {
  constructor(element) {
    this.element = element;
  }

  get htmlElement() {
    return this.element;
  }

  set name(name) {
    this.element.querySelector('[data-role="name"]').innerHTML = name;
    this.element.querySelector('input').value = name;
  }
};

export { FieldTierVisibility };